import type { PromotionAction } from '~/lib/schemas/actions';
import { PercentageDiscountBody } from './percentage-discount';
import { ValueDiscountBody } from './value-discount';
import { FixedPriceBody } from './fixed-price';
import { BogoBody } from './bogo';
import { GiftProductBody } from './gift-product';
import { PerProductDiscountBody } from './per-product-discount';
import { CategoryDiscountBody } from './category-discount';
import { ShippingDiscountBody } from './shipping-discount';

interface ActionBodyProps {
	value: PromotionAction;
	onChange: (next: PromotionAction) => void;
}

/** Dispatches to the type-specific body. TS narrows `value` in each case. */
export function ActionBody({ value, onChange }: ActionBodyProps) {
	switch (value.type) {
		case 'percentage-discount':
			return <PercentageDiscountBody value={value} onChange={onChange} />;
		case 'value-discount':
			return <ValueDiscountBody value={value} onChange={onChange} />;
		case 'fixed-price':
			return <FixedPriceBody value={value} onChange={onChange} />;
		case 'bogo':
			return <BogoBody value={value} onChange={onChange} />;
		case 'gift-product':
			return <GiftProductBody value={value} onChange={onChange} />;
		case 'per-product-discount':
			return <PerProductDiscountBody value={value} onChange={onChange} />;
		case 'category-discount':
			return <CategoryDiscountBody value={value} onChange={onChange} />;
		case 'shipping-discount':
			return <ShippingDiscountBody value={value} onChange={onChange} />;
	}
}
